import VPageCardAddRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageCardAddRecord', VPageCardAddRecord),
};
